const account_center = {
    not_enabled: "Le centre de compte n'est pas activé.",
    field_not_editable: "Le champ n'est pas modifiable.",
    field_not_enabled: "Le champ n'est pas activé.",
};
export default Object.freeze(account_center);
